<template>
  <div class="col-sm-12 box-shadow">
    <advanced :col="col" :getData="getData" :DownloadURL="DownloadURL" :Options="Options"/>
  </div>
</template>
<script>
import Advanced from './Advanced/'
//import capitalize from 'lodash/capitalize'

export default {
  components: { Advanced },
  props: ['col','getData','DownloadURL','Options'],
  data: () => ({
    showTab: getCurHash()
  }),
  mounted () {
    
  },
  methods: {
    viewSource () {
      /*window.open(`https://github.com/OneWayTech/vue2-datatable/blob/master/examples/src/${capitalize(this.showTab)}/index.vue`)*/
    },
  }
}

function getCurHash() {
  // display Advanced example by default
  return location.hash.replace(/^#/, '') || 'advanced'
}
</script>
<style>
html {
  position: relative;
  min-height: 100%;
}
footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 5px 0;
  font-size: 12px;
  text-align: center;
  color: #afafaf;
}
</style>
